export default "__VITE_ASSET__DsC7dwna__"